import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IRouteReducerSliceStateInit } from "../slice_interface";
import {
  ITilesCollectionOptionsResponseData,
  ITilesListResponseData,
  ITilesOnboardBody,
  ITilesViewResponseData,
} from "@/api_framework/api_modals/Tiles";

export interface ITilesState {
  tilesList: ITilesListResponseData;
  tilesAdd: ITilesOnboardBody | null;
  tilesView: ITilesViewResponseData;
  tilesConsultation: ITilesCollectionOptionsResponseData[];
}
export interface ITilesInitialState extends IRouteReducerSliceStateInit {
  state: ITilesState;
}

const initialState: ITilesInitialState = {
  state: {
    tilesList: null,
    tilesAdd: null,
    tilesView: null,
    tilesConsultation: [],
  },
};

const tilesSlice = createSlice({
  name: "tiles_slice",
  initialState: initialState,
  reducers: {
    // RESET_INVENTORY: () => {
    //   return initialState;
    // },
    setTilesList: (
      state,
      action: PayloadAction<{
        data: ITilesListResponseData;
      }>,
    ) => {
      state.state.tilesList = action.payload.data;
    },
    setTilesAdd: (
      state,
      action: PayloadAction<{
        data: ITilesOnboardBody;
      }>,
    ) => {
      state.state.tilesAdd = action.payload.data;
    },
    setTilesView: (
      state,
      action: PayloadAction<{
        data: ITilesViewResponseData;
      }>,
    ) => {
      state.state.tilesView = action.payload.data;
    },
    setTilesConsultation: (
      state,
      action: PayloadAction<{
        data: ITilesCollectionOptionsResponseData[];
      }>,
    ) => {
      state.state.tilesConsultation = action.payload.data;
    },
  },
});

export const { setTilesList, setTilesAdd, setTilesView, setTilesConsultation } = tilesSlice.actions;
export default tilesSlice.reducer;
